var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 1032,
    viewBox: "0 0 608 1032",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.496 374.493V256.493M116.496 256.493V95.4928C116.496 23.0001 224.496 27.4914 224.496 95.493C224.496 -8.49886 355.996 -5.99922 355.996 95.4928C355.996 18.9999 476.496 23.4999 476.496 95.4928V148.993C476.496 66.4999 590.496 75.4999 590.496 148.993V484.493C590.496 564 509.496 615.493 509.496 615.493V963.493C509.496 1003.5 489.496 1013.99 458.996 1013.99H234.496C197.996 1013.99 166.496 1013.99 166.496 963.493V615.493C104 583.5 48 488 48 488C48 488 18 433 17.9961 392.493C17.9961 299 50.9961 282 116.496 256.493Z",
    stroke: "black",
    strokeWidth: 35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeOff);
export default __webpack_public_path__ + "static/media/TakeOff.a4febcde1c5110efff119e19bcc817de.svg";
export { ForwardRef as ReactComponent };